import { combineReducers } from 'redux'
import {
  USER_TYPE_PAGE_ERROR, USER_TYPE_PAGE_LOADING, USER_TYPE_LIST_SUCCESS,
  USER_TYPE_VIEW_SUCCESS, USER_TYPE_PAGE_SUCCESS, USER_TYPE_VIEW_ERROR,
  USER_TYPE_ADD_ERROR, USER_TYPE_ADD_LOADING, USER_TYPE_ADD_SUCCESS,
  USER_TYPE_VIEW_LOADING, USER_TYPE_DELETE_ERROR, USER_TYPE_DELETE_LOADING, 
  USER_TYPE_DELETE_SUCCESS, USER_TYPE_UPDATE_SUCCESS, USER_TYPE_UPDATE_ERROR, USER_TYPE_UPDATE_LOADING, USER_TYPE_LIST_ERROR, USER_TYPE_LIST_LOADING
} from './constant'

const userTypePageError = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_PAGE_ERROR:
      return action.userTypePageError
    default:
      return state
  }
}

const userTypePageLoading = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_PAGE_LOADING:
      return action.userTypePageLoading
    default:
      return state
  }
}

const userTypePageSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_PAGE_SUCCESS:
      return action.userTypePageSuccess
    default:
      return state
  }
}

const userTypes = (state = [], action) => {
  switch (action.type) {
    case USER_TYPE_PAGE_SUCCESS:
      return action.userType
    case USER_TYPE_LIST_SUCCESS:
      return action.userType
    default:
      return state
  }
}

const userType = (state = [], action) => {
  switch (action.type) {
    case USER_TYPE_VIEW_SUCCESS:
      return action.userType
    default:
      return state
  }
}

const userTypeAddError = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_ADD_ERROR:
      return action.userTypeAddError
    default:
      return state
  }
}

const userTypeAddLoading = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_ADD_LOADING:
      return action.userTypeAddLoading
    default:
      return state
  }
}

const userTypeAddSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_ADD_SUCCESS:
      return action.userTypeAddSuccess
    default:
      return state
  }
}

const userTypeViewError = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_VIEW_ERROR:
      return action.userTypeViewError
    default:
      return state
  }
}

const userTypeViewLoading = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_VIEW_LOADING:
      return action.userTypeViewLoading
    default:
      return state
  }
}

const userTypeViewSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_VIEW_SUCCESS:
      return action.userTypeViewSuccess
    default:
      return state
  }
}

const userTypeDeleteError = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_DELETE_ERROR:
      return action.userTypeDeleteError
    default:
      return state
  }
}

const userTypeDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_DELETE_LOADING:
      return action.userTypeDeleteLoading
    default:
      return state
  }
}

const userTypeDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_DELETE_SUCCESS:
      return action.userTypeDeleteSuccess
    default:
      return state
  }
}

const userTypeUpdateError = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_UPDATE_ERROR:
      return action.userTypeUpdateError
    default:
      return state
  }
}

const userTypeUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_UPDATE_LOADING:
      return action.userTypeUpdateLoading
    default:
      return state
  }
}

const userTypeUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_UPDATE_SUCCESS:
      return action.userTypeUpdateSuccess
    default:
      return state
  }
}

const userTypeListError = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_LIST_ERROR:
      return action.userTypeListError
    default:
      return state
  }
}

const userTypeListLoading = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_LIST_LOADING:
      return action.userTypeListLoading
    default:
      return state
  }
}

const userTypeListSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_TYPE_LIST_SUCCESS:
      return action.userTypeListSuccess
    default:
      return state
  }
}

const userTypeReducer = combineReducers({
  userTypePageError,
  userTypePageLoading,
  userTypePageSuccess,

  userTypes,
  userType,

  userTypeAddError,
  userTypeAddLoading,
  userTypeAddSuccess,

  userTypeViewError,
  userTypeViewLoading,
  userTypeViewSuccess,

  userTypeDeleteError,
  userTypeDeleteLoading,
  userTypeDeleteSuccess,

  userTypeUpdateError,
  userTypeUpdateLoading,
  userTypeUpdateSuccess,

  userTypeListError,
  userTypeListLoading,
  userTypeListSuccess,
})

export default userTypeReducer
